import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import InformacionGeneralSection from './InformacionGeneralSection';
import DatosBancariosSection from './DatosBancariosSection';
import InformacionAdicionalSection from './InformacionAdicionalSection';

const ProveedorFormModal = ({ 
    visible, 
    isEditing, 
    provider,
    categorias,
    ciudades,
    onHide, 
    onSave,
    onInputChange,
    onInputNumberChange,
    onCheckboxChange,
    onDropdownChange,
    onCalendarChange
}) => {
    const dialogFooter = (
        <div>
            <Button 
                label="Cancelar" 
                icon="pi pi-times" 
                onClick={onHide} 
                className="p-button-text" 
            />
            <Button 
                label={isEditing ? "Guardar" : "Crear"} 
                icon="pi pi-check" 
                onClick={onSave} 
            />
        </div>
    );

    return (
        <Dialog 
            visible={visible} 
            style={{ width: '1000px', maxHeight: '90vh' }} 
            header={isEditing ? "Editar Proveedor" : "Crear Proveedor"} 
            modal 
            className="p-fluid" 
            footer={dialogFooter} 
            onHide={onHide}
        >
            <div className="grid">
                <InformacionGeneralSection 
                    provider={provider}
                    isEditing={isEditing}
                    categorias={categorias}
                    ciudades={ciudades}
                    onInputChange={onInputChange}
                    onInputNumberChange={onInputNumberChange}
                    onCheckboxChange={onCheckboxChange}
                    onDropdownChange={onDropdownChange}
                    onCalendarChange={onCalendarChange}
                />

                <DatosBancariosSection 
                    provider={provider}
                    onInputChange={onInputChange}
                />

                <InformacionAdicionalSection 
                    provider={provider}
                    onInputChange={onInputChange}
                />
            </div>
        </Dialog>
    );
};

export default ProveedorFormModal;
